import React, { ChangeEvent, RefObject } from 'react';

import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

import './index.scss';

export default function FileField({
  filename,
  fileRef,
  onChange,
}: {
  filename: string;
  fileRef: RefObject<HTMLInputElement | null>;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}) {
  return (
    <div className="upload-file-field">
      <span className="upload-file-field-label">Arquivo (.zip)</span>
      <label className="upload-file-field-drop" htmlFor="fluxFileInputMobile">
        <Icon iconType="upload" color={cssVar('text-accent')} size="large" />
        <span className="upload-file-field-name">
          {filename || 'Selecionar arquivo .zip'}
        </span>
        <span className="upload-file-field-hint">
          {filename ? 'Toque para trocar' : 'Um único zip, sem pastas internas'}
        </span>
        <input
          ref={fileRef}
          type="file"
          id="fluxFileInputMobile"
          accept=".zip"
          onChange={onChange}
        />
      </label>
    </div>
  );
}
